module.exports = __webpack_public_path__ + "img/admin_adv_25.89a8c183.png";